import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'


@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
  }
  getQuery() {
    // 获取 hash 中的查询字符串部分
    let hash = window.location.hash
    let queryString = hash.includes('?') ? hash.split('?')[1] : ''

    queryString = queryString.replace(/\\\\/g, '\\')

    // 将 URL 编码中的 \u0026 替换为 &
    let cleanQuery = decodeURIComponent(queryString).replace(/\\u0026/g, '&')

    // 解析参数
    let params = new URLSearchParams(cleanQuery)

    // 提取所需参数
    let GameURL = params.get('GameURL')
    let pl = params.get('pl')
    let v = params.get('v')
    let uid = params.get('uid')
    let token = params.get('token')
    let lang = params.get('lang')
    let time = params.get('time')
    let sdk = params.get('sdk')
    let roomId = params.get('roomId')

    // // 输出结果
    // console.log('uid:', uid)
    // console.log('accesstoken:', accesstoken)
    // console.log('GameURL:', GameURL)
    // console.log('lang:', lang)

    return {
      GameURL: GameURL,
      pl: pl,
      v: v,
      uid: uid,
      token: token,
      lang: lang,
      time: time,
      sdk: sdk,
      roomId: roomId
    }
  }

  render() {
    let { GameURL, pl, v, uid, token, lang, time, roomId } = this.getQuery()
    return (
      <div className={`gamehkys`}>
        {GameURL && GameURL != '' && <iframe
          className="app-games-iframe"
          id='iframe'
          src={`${GameURL}?pl=${pl || ''}&v=${v || ''}&uid=${uid || ''}&token=${token || ''}&lang=${lang || ''}&time=${time || ''}&roomId=${roomId || ''}`}
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
        </iframe>}
        {/* <div className={`blankSpace`}></div> */}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/game-hkys/index.js